import React from "react";
import Icon from "./Icon";

export const InstantRental = () => (
  <Icon>
    <circle cx="12" cy="12" r="12" fill="#23410A"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 6.55433V13.7933C9 14.2357 9.36453 14.5976 9.81006 14.5976H11.4302V20.3486C11.4302 20.7588 11.9729 20.9035 12.1836 20.5496L16.3878 13.3911C16.7037 12.8522 16.3149 12.1846 15.6911 12.1846H13.8604L15.8775 6.83584C16.08 6.31303 15.6911 5.75 15.1241 5.75H9.81006C9.36453 5.75 9 6.11195 9 6.55433Z" fill="white"/>
  </Icon>
);
